














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AtSign extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly fill?: string;
}
